import React, { useState, forwardRef } from "react";
import * as _f_ from "@Funciones/funciones";
import "@Estilos/Div.css";

export const Div = ({
  texto,
  tipo = "text",
  name,
  estilos = {},
  ...props
} ) => {
  return (
    <div className="Div" id={`Div-${name}`} style={_f_.estilosObjetoVariablesCSS(estilos)} {...props}>
      {(texto ?? "")}
    </div>   
  );
};

export const Div2 = ({
  texto,
  tipo = "text",
  name,
  estilos = {},
  ...props
} ) => {
  return (
    <div className="Div2" id={`Div-${name}`} style={_f_.estilosObjetoVariablesCSS(estilos)} {...props}>
      {(texto ?? "")}
    </div>   
  );
};

export const Div3 = ({
  cabecera,
  texto,
  tipo = "text",
  name,
  estilos = {},
  ...props
} ) => {
  return (
    <div className="Div3CSS" id={`Div-${name}`} style={_f_.estilosObjetoVariablesCSS(estilos)} {...props}>
      <div className="Div3CSS-cabecera">{(cabecera ?? "")}</div>
      <div className="Div3CSS-texto">{(texto ?? "")}</div>
    </div>   
  );
};

